import type { RouteRecordRaw } from 'vue-router'
import SettlementsPage from './SettlementsPage.vue'

export const settlementsRoutes: RouteRecordRaw[] = [
  {
    path: '/treasury/settlements',
    name: 'treasury.settlements',
    component: SettlementsPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
